import { render, staticRenderFns } from "./emptyList.vue?vue&type=template&id=032e5ffe"
import script from "./emptyList.vue?vue&type=script&lang=js"
export * from "./emptyList.vue?vue&type=script&lang=js"
import style0 from "./emptyList.vue?vue&type=style&index=0&id=032e5ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports